import type {
  ProjectFeature,
  ProjectItem,
} from '@store/reducers/dashboard/types'

export const isEnabled = (project: ProjectItem) => {
  const map = new Set<ProjectFeature>(project.features)

  const archive = map.has('archive')
  const move = map.has('move')
  const remove = map.has('delete')
  const archive_badge = map.has('archive_badge')
  const transfer = map.has('transfer')
  const duplicate = map.has('duplicate')

  return { archive_badge, archive, move, remove, transfer, duplicate }
}
